module.exports = __webpack_public_path__ + "img/money-cny-circle-fill.8bc9c544.svg";